<template>
  <div>
    <div class="kit__utils__heading">
      <h5>
        <span class="mr-3">Gestión Niveles de Escolaridad</span>
      </h5>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col">
            <h5 class="mb-4">
              <strong>Crear Nivel</strong>
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <a-divider orientation="left"><strong>Lista de Niveles</strong>
              <b-button variant="primary" @click="openModal(null)" style="position: absolute; right: 2rem; top: -0.5em; z-index: 1;">Crear</b-button>
            </a-divider>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <h5 class="mb-4">
              <a-table v-if="data.length > 0" :columns="columns" :dataSource="data" rowKey="id" :pagination=false>
                 <div slot="action" slot-scope="level">
                  <a @click="() => openModal(level)">Editar</a>
                </div>
              </a-table>
              <empty-table v-else/>
            </h5>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="level" ref="modal" :title="form.isEditing ? 'Actualizar nivel' : 'Crear nivel'" hide-footer @hidden="onHidden">
      <b-form @submit.prevent="save(form)" ref="todoform">
        <b-form-group id="input-group-1-edit" label="Nombre:" label-for="input-1" description="Ejemplo: Básica Primaria">
          <b-form-input id="input-1-edit" v-model="form.name" required placeholder="Ingrese el nombre"></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-2-edit" label="Orden:" label-for="input-2" description="Ejemplo: 2">
          <b-form-select v-model="form.order" :options="orderAvailable" required></b-form-select>
        </b-form-group>
        <b-button type="submit" variant="primary" class="mb-3 mt-3">{{ form.isEditing ? 'Actualizar' : 'Guardar' }}</b-button>
        <b-button @click="$bvModal.hide('level')" variant="secondary" size="sm" class="mr-2 mb-3 mt-3">Cancelar</b-button>
      </b-form>
    </b-modal>
  </div>
</template>
<script>
import apiClient from '@/services/axios'
import apiClient2 from '@/services/axios/v2'
import { mapState } from 'vuex'
import Swal from 'sweetalert2'
import emptyTable from '@/components/custom/cardEmptyList'
import { showErrorMessage } from '@/services/utilities'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 8000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

const columns = [
  { title: 'Orden', dataIndex: 'order', key: 'order' },
  { title: 'Nombre', dataIndex: 'name', key: 'name' },
  { title: 'Acción', dataIndex: '', key: 'x', scopedSlots: { customRender: 'action' } },
]

export default {
  name: 'educationLevel',
  components: {
    emptyTable,
  },
  data() {
    return {
      form: {
        isEditing: false,
        id: '',
        name: '',
        order: null,
      },
      data: [],
      limit: 1,
      orderAvailable: [
        { value: null, text: 'Seleccione una opción' },
      ],
      columns,
    }
  },
  computed: {
    ...mapState(['user']),
  },
  beforeRouteEnter (to, from, next) {
    apiClient2.get('/education-levels').then(response => {
      next(vm => vm.setData('', response.data.data))
    }).catch(err => {
      next(vm => vm.setData(err, [])) // TODO Mostrar error
    })
  },
  methods: {
    setData (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        this.data = data.rows
        this.limit = (data.count > 0) ? data.count + 1 : 1
        this.orderAvailable.length = 1
        for (let i = 1; i <= this.limit; i++) {
          this.orderAvailable.push({ value: i, text: i })
        }
      }
    },
    changeOrder (order) {
      if (order.order === '' || !order.order >= 1 || order.order > this.data.length) {
        Toast.fire({
          icon: 'warning',
          title: (order.order > this.data.length) ? 'El orden no puede tener un valor mayor a la cantidad de niveles disponibles' : 'El orden no puede estar vácio o ser menor a 1',
        })
        return
      }
      apiClient.patch('/areas/order/' + order.id, { order: order.order }).then(response => {
        apiClient.get('/areas').then(response => {
          this.setData('', response.data.results.rows)
        })
        Toast.fire({
          icon: 'success',
          title: 'Nivel actualizado con éxito',
        })
      }).catch(err => {
        this.$notification.warning({
          message: 'Ooops ocurrio un error',
          description: showErrorMessage(err),
        })
      })
    },
    onHidden() {
      this.form = {
        isEditing: false,
        name: '',
        order: null,
      }
    },
    save(form) { // Guarda un grado llamando a la API
      if (this.form.isEditing) {
        const data = {
          ...(form.name && { name: form.name }),
          ...(form.order && { order: form.order }),
        }
        apiClient2.patch(`/education-levels/${this.form.id}`, data).then(response => {
          this.$notification.success({
            message: 'Modificación exitosa',
          })
          this.data.forEach(element => {
            if (element.id === this.form.id) {
              element.name = data.name ? data.name : element.name
              element.order = data.order ? data.order : element.order
            }
          })
          this.$bvModal.hide('level')
        }).catch(err => {
          this.$notification.success({
            message: 'Ooops ocurrio un error',
            description: showErrorMessage(err),
          })
        })
      } else {
        apiClient2.post('/education-levels', this.form).then(response => {
          this.data.push(response.data.data)
          const i = this.orderAvailable.length
          this.orderAvailable.push({ value: i, text: i })
          Toast.fire({
            icon: 'success',
            title: 'Creado exitosamente',
          })
          this.$bvModal.hide('level')
        }).catch(err => {
          this.$notification.success({
            message: 'Ooops ocurrio un error',
            description: showErrorMessage(err),
          })
        })
        this.form.name = ''
        this.form.order = null
      }
    },
    openModal(level) { // Abre el modal para editar el grado
      if (level !== null) {
        this.form = Object.assign({}, level)
        this.form.isEditing = true
      }
      this.$bvModal.show('level')
    },
    edit(evt) { // Edita un grado llamando a la API
      evt.preventDefault()
      apiClient.patch(`/areas/${this.areaToEdit.id}`, this.areaToEdit).then(response => {
        this.data = this.data.map(x => (x.id === response.data.id) ? response.data : x)
        this.$notification.success({
          message: 'Modificación exitosa',
          description:
            `Se modificó el nivel ${response.data.name} correctamente.`,
        })
        this.$bvModal.hide('level')
      }).catch(err => {
        this.$notification.success({
          message: 'Ooops ocurrio un error',
          description: showErrorMessage(err),
        })
      })
    },
    onReset(evt) {
      evt.preventDefault()
      // Reset our form values
      this.form.name = ''
      this.form.order = null
    },
  },
}
</script>
